export const SET_BLOBS = 'SET_BLOBS'
export const SET_BLOB = 'SET_BLOB'
export const SET_BLOB_DATA = 'SET_BLOB_DATA'
export const RESET_BLOB = 'RESET_BLOB'
export const SET_CHECKED = 'SET_CHECKED'
export const SET_PAGER = 'SET_PAGER'
export const RESET_BLOBS = 'RESET_BLOBS'

export const STORE_PAGER = 'storage/pager'
